'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _sortBy2 = require('lodash/sortBy');

var _sortBy3 = _interopRequireDefault(_sortBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cbWaitingTimeController($attrs, WebApiService, waitingTimeConstants) {
    var vm = this;
    var skillCodes = $attrs['cbWaitingTime'].length > 0 ? JSON.parse($attrs['cbWaitingTime']) : undefined;

    var requestData = {
        'skillcodes': skillCodes
    };

    vm.showLoading = true;
    vm.showError = false;

    function parseWaitingTime(inputSeconds) {
        var seconds = parseInt(inputSeconds, 10);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);

        if (hours > 0) {
            return hours + ' uur';
        } else if (minutes > 1) {
            return minutes + ' minuten';
        } else if (minutes === 1) {
            return minutes + ' minuut';
        } else {
            return 'minder dan 1 minuut';
        }
    }

    function setColor(inputSeconds) {
        if (inputSeconds < 300) {
            return 'u-text-green';
        } else if (inputSeconds < 900) {
            return 'u-text-mais';
        } else {
            return 'u-text-mandarijn';
        }
    };

    WebApiService.get(requestData, 'OphalenWachttijden').then(function (result) {
        var skillCodes = (0, _sortBy3.default)(result.skillcodes, 'code');
        vm.waitingTimeData = [];

        skillCodes.forEach(function (skillCode) {
            var waitingTimeDetails = {};
            var skillCodeDetails = skillCode.kanalen[0].details;

            waitingTimeDetails.time = parseWaitingTime(skillCodeDetails.langsteWachttijdInSeconden);
            waitingTimeDetails.color = setColor(skillCodeDetails.langsteWachttijdInSeconden);
            waitingTimeDetails.skill = waitingTimeConstants.SKILLNAMES[skillCode.code];
            vm.waitingTimeData.push(waitingTimeDetails);
        });
        vm.showLoading = false;
    }).catch(function (error) {
        vm.showError = true;
        throw new Error('Could not get waiting times: ' + error);
    });
}

cbWaitingTimeController.$inject = ['$attrs', 'WebApiService', 'waitingTimeConstants'];

exports.default = cbWaitingTimeController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/waiting-time/cb-waiting-time.controller.js
// module id = 925
// module chunks = 0